/**
 * Máscaras de input BR.
 *
 * Nasceu com a PWA de indicações (src/indica/) e é usada também pela aba
 * Indicações do painel. `formatPhone` existe hoje copiada em 6 arquivos
 * (SejaConsultora, DevicesPanel, ForwardModal, IncentivePanel,
 * AssignLeaderModal, LeaderCoverageView) — este módulo é o lugar pra onde elas
 * devem migrar quando alguém encostar nelas. Não foram migradas junto pra não
 * misturar refatoração alheia com feature nova.
 */

/** (67) 99999-8888 — progressiva, para não brigar com o cursor ao digitar. */
export function formatPhone(v: string): string {
  const d = String(v || '').replace(/\D/g, '').slice(0, 11)
  if (d.length <= 2) return d
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

/** 529.982.247-25 */
export function formatCpf(v: string): string {
  const d = String(v || '').replace(/\D/g, '').slice(0, 11)
  if (d.length <= 3) return d
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
}

export const soDigitos = (v: string): string => String(v || '').replace(/\D/g, '')

/**
 * Validação de CPF no cliente — só pra dar feedback imediato no formulário.
 * A validação que VALE é a do servidor (lib/indica-rules.cjs): esta roda numa
 * página pública e não é confiável.
 */
export function cpfValido(v: string): boolean {
  const cpf = soDigitos(v)
  if (cpf.length !== 11) return false
  if (/^(\d)\1{10}$/.test(cpf)) return false
  let soma = 0
  for (let i = 0; i < 9; i++) soma += parseInt(cpf[i], 10) * (10 - i)
  let d1 = (soma * 10) % 11
  if (d1 === 10) d1 = 0
  if (d1 !== parseInt(cpf[9], 10)) return false
  soma = 0
  for (let i = 0; i < 10; i++) soma += parseInt(cpf[i], 10) * (11 - i)
  let d2 = (soma * 10) % 11
  if (d2 === 10) d2 = 0
  return d2 === parseInt(cpf[10], 10)
}

/** Data/hora curta pra timeline: "4 ago, 14:32". */
export function dataHoraCurta(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString('pt-BR', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  })
}
